/**
 * CabIdGate · route-level gate for the CAB-ID program.
 *
 * Renders its children for users with CAB-ID access (global flag on, or a
 * platform admin dogfooding), and the existing "coming soon" panel for everyone
 * else. Replaces the old inline `CAB_ID_ENABLED ? <Page/> : <CabIdComingSoon/>`
 * checks in App.tsx so admins can test the flow while it stays dark for users.
 */

import type { ReactNode } from "react";
import { CabIdComingSoon } from "@/components/CabIdComingSoon";
import { useCabIdAccess } from "@/hooks/useCabIdAccess";

export function CabIdGate({
  children,
  verifyHref,
}: {
  children: ReactNode;
  verifyHref?: string;
}) {
  const { allowed, loading } = useCabIdAccess();
  // Fail closed while the role resolves: render nothing rather than flashing
  // either the program or the coming-soon panel.
  if (loading) return null;
  if (!allowed) return <CabIdComingSoon verifyHref={verifyHref} />;
  return <>{children}</>;
}
